export const normalizeLegacySignatures = (userDetails) => {
	if (Array.isArray(userDetails?.emailSignatures) && userDetails.emailSignatures.length > 0) {
		return userDetails.emailSignatures.map((signature) => ({
			...signature,
			email: signature?.email ?? signature?.name ?? '',
		}));
	}

	if (userDetails?.signatureHtmlUrl) {
		return [
			{
				email: userDetails?.displayEmail ?? userDetails?.email ?? '',
				name: userDetails?.displayEmail ?? userDetails?.email ?? 'Default signature',
				signature: userDetails.signatureHtmlUrl,
			},
		];
	}

	return [];
};
